module.exports = __webpack_public_path__ + "static/media/nb0.dc5e79e6.png";